(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("checkoutStep2Address", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/checkout/checkoutStep2AddressView.html",
            controller: ["authService", "checkoutService", "checkoutResource", "globalizationService", "myAccountResource", "messageService", "$state", "$timeout", "_", CheckoutStep2AddressCtrl],
            controllerAs: "vm"
        };
        function CheckoutStep2AddressCtrl(authService, checkoutService, checkoutResource, globalizationService, myAccountResource, messageService, $state, $timeout, _) {
            var vm = this;
            vm.loading = true;
            vm.showProceed = false;
            vm.hasTaxExemptDomain = false;
            vm.showErrors = false;
            vm.formData = checkoutService.model;
            vm.countrySettings = {};
            vm.profileRecord = {};
            vm.email = authService.authentication.userEmail;
            if (!checkoutService.wizard.isStep1Valid) {
                $state.go("main.checkout.step1", {}, { location: "replace" });
                return;
            }
            checkoutService.setStep(2);
            checkoutResource.get(function (result) {
                vm.countrySettings.enabledCountries = result.enabledCountries;
                vm.formData.billingAddress = result.billingAddress;
                if (result.billingAddress) {
                    vm.formData.billingAddress.saveToAccount = false;
                    if (result.billingAddress.countryId)
                        vm.loadStateProvince(result.billingAddress.countryId);
                }
                else {
                    vm.formData.billingAddress = { saveToAccount: true };
                }
                vm.hasTaxExemptDomain = result.hasTaxExemptDomain && vm.email;
                if (vm.hasTaxExemptDomain) {
                    vm.showSendVerification = true;
                }
                else {
                    vm.showProceed = true;
                }
                $timeout(function () {
                    vm.loading = false;
                });
            }, function (error) {
                messageService.error(error);
            });
            vm.loadStateProvince = function (countryId) {
                var countryObj = _.find(vm.countrySettings.enabledCountries, { id: countryId });
                //console.log(countryObj);
                globalizationService.load(countryObj.threeLetterISOCode, function (result) {
                    vm.stateProvinceLabel = result.stateProvinceLabel;
                    vm.postalZipLabel = result.postalZipLabel;
                    vm.postalZipRegex = new RegExp(result.postalZipRegex);
                    vm.postalZipPattern = result.postalZipPattern;
                });
                vm.countrySettings.stateProvinces = countryObj.provinces;
                // no provinces?
                if (vm.countrySettings.stateProvinces.length === 0)
                    vm.formData.billingAddress.stateProvinceId = null;
                else {
                    // if current value not in list, show the 'select one' option
                    if (!_.find(vm.countrySettings.stateProvinces, { id: vm.formData.billingAddress.stateProvinceId })) {
                        vm.formData.billingAddress.stateProvinceId = 0;
                    }
                }
            };
            vm.sendTaxExemptVerificationEmail = function () {
                if (vm.buttonClicked)
                    return;
                vm.buttonClicked = true;
                checkoutResource.sendTaxExemptVerificationEmail(function () {
                    vm.buttonClicked = false;
                    vm.showSendVerification = false;
                    vm.showVerify = true;
                });
            };
            vm.verifyTaxExemptStatus = function () {
                if (vm.verify)
                    return;
                vm.verify = true;
                vm.error = "";
                checkoutResource.verifyTaxExemptCode({ value: vm.verificationCode }, function () {
                    vm.verify = false;
                    vm.formData.taxExemptDomain = true;
                    vm.next();
                }, function (error) {
                    vm.verify = false;
                    vm.error = error.data.message;
                });
            };
            vm.next = function () {
                if (vm.step2form.$valid) {
                    //IF updateAccountAddress IS CHECKED, SAVE ADDRESS AND CONTINUE
                    if (vm.formData.billingAddress.saveToAccount) {
                        var person = $state.params.personSeq;
                        myAccountResource.get(function (result) {
                            vm.profileRecord = result;
                            var billingInfoBindingModel = {
                                id: vm.profileRecord.id,
                                addressLine1: vm.formData.billingAddress.addressLine1,
                                addressLine2: vm.formData.billingAddress.addressLine2,
                                city: vm.formData.billingAddress.city,
                                postalCode: vm.formData.billingAddress.countryId ? vm.formData.billingAddress.zipPostalCode : null,
                                provinceId: vm.formData.billingAddress.stateProvinceId ? vm.formData.billingAddress.stateProvinceId : 0,
                                countryId: vm.formData.billingAddress.countryId ? vm.formData.billingAddress.countryId : 0,
                                IgnoreValidation: true
                            };
                            myAccountResource.updateMyAddressInformation({ personSeq: person }, billingInfoBindingModel, function () {
                                messageService.success("account.profile.edit.billingInformation.success");
                            }, function (error) {
                                messageService.error(error);
                            });
                        }, function (error) {
                            messageService.error(error);
                        });
                    }
                    $state.go("main.checkout.step3", {}, { location: "replace" });
                    checkoutService.wizard.isStep2Valid = true;
                }
                else {
                    vm.showErrors = true;
                }
            };
        }
    });
}());
